<template>
    <div class="main-div">
        <v-header title="团队继续率"></v-header>
        <div class="teamConrate">
            <div class="header">
                <label>{{username}}团队继续率</label>
                <div class="right">
                    <span>宽限期末年月</span>
                    <el-date-picker
                        :clearable='false'
                        type="month"
                        :editable="false"
                        size="mini"
                        v-model="month"
                        :picker-options="pickerOptions0"
                        >
                    </el-date-picker>

                </div>
            </div>
            <div class="main">
                <div class="option">
                    <ul>
                        <li @click="chooseType('13')" :class="[req.conRateType==='13'?'typeSelected':'']"><span>13个月</span></li>
                        <li @click="chooseType('25')" :class="[req.conRateType==='25'?'typeSelected':'']"><span>25个月</span></li>
                        <li @click="chooseType('37')" :class="[req.conRateType==='37'?'typeSelected':'']"><span>37个月及以上</span></li>
                    </ul>
                </div>
                <div class="content">
                    <div class="moneyTotal">
                        <div class="title" @click="arrow('money','money-content')">
                            <label>在职单统计</label> <img id="money" class="arrow" src="../../../static/image/arrow.png" />
                        </div>
                        <div class="money-content" id="money-content">
                            <table>
                                <thead>
                                    <th>在职单应收保费（月）</th>
                                    <th>在职单实收保费（月）</th>
                                    <th>在职单应收保费（年）</th>
                                    <th>在职单实收保费（年）</th>
                                    <th>在职单继续率（月）</th>
                                    <th>在职单继续率（年）</th>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{{result.instprem_n_m}}</td>
                                        <td>{{result.realprem_n_m}}</td>
                                        <td>{{result.instprem_n_y}}</td>
                                        <td>{{result.realprem_n_y}}</td>
                                        <td>{{result.realprem_nm_rate ? result.realprem_nm_rate + '%' : '' }}</td>
                                        <td>{{result.realprem_ny_rate ? result.realprem_ny_rate + '%' : '' }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="moneyTotal">
                        <div class="title" @click="arrow('orphan','orphan-content')">
                            <label>孤儿单统计</label> <img id="orphan" class="arrow" src="../../../static/image/arrow.png" />
                        </div>
                        <div  id="orphan-content" class="money-content">
                            <table>
                                <thead>
                                    <th>孤儿单应收保费（月）</th>
                                    <th>孤儿单实收保费（月）</th>
                                    <th>孤儿单应收保费（年）</th>
                                    <th>孤儿单实收保费（年）</th>
                                    <th>孤儿单继续率（月）</th>
                                    <th>孤儿单继续率（年）</th>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{{result.instprem_o_m}}</td>
                                        <td>{{result.realprem_o_m}}</td>
                                        <td>{{result.instprem_o_y}}</td>
                                        <td>{{result.realprem_o_y}}</td>
                                        <td>{{result.realprem_om_rate ? result.realprem_om_rate + '%' : '' }}</td>
                                        <td>{{result.realprem_oy_rate ? result.realprem_oy_rate + '%' : '' }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="moneyTotal">
                        <div class="title" @click="arrow('rate','rate-content')">
                            <label>继续率统计</label> <img id="rate" class="arrow" src="../../../static/image/arrow.png" />
                        </div>
                        <div id="rate-content" class="money-content">
                            <table>
                                <thead>
                                    <th>合计应收保费（月）</th>
                                    <th>合计实收保费（月）</th>
                                    <th>合计应收保费（年）</th>
                                    <th>合计实收保费（年）</th>
                                    <th>合计继续率（月）</th>
                                    <th>合计继续率（年）</th>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{{result.instprem_m}}</td>
                                        <td>{{result.realprem_m}}</td>
                                        <td>{{result.instprem_y}}</td>
                                        <td>{{result.realprem_y}}</td>
                                        <td>{{result.realprem_m_rate ? result.realprem_m_rate + '%' : '' }}</td>
                                        <td>{{result.realprem_y_rate ? result.realprem_y_rate + '%' : '' }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
import url from '@/modules/url'
import api from '@/modules/api'
import vHeader from '@/layout/Header1.vue'
export default {
  components: {vHeader},
  data () {
    return {
      username: '',
      month: '',
      req: {
        billcdDate: '',
        conRateType: '13',
        teamType: '',
        grouptlCode: null,
        depttlCode: null,
        areatlCode: null

      },
      result: {
        areaCode: '',
        areaName: '',
        deptCode: '',
        deptName: '',
        instprem_m: '',
        instprem_n_m: '',
        instprem_n_y: '',
        instprem_o_m: '',
        instprem_o_y: '',
        instprem_y: '',
        realprem_m: '',
        realprem_m_rate: '',
        realprem_n_m: '',
        realprem_n_y: '',
        realprem_nm_rate: '',
        realprem_ny_rate: '',
        realprem_o_m: '',
        realprem_o_y: '',
        realprem_om_rate: '',
        realprem_oy_rate: '',
        realprem_y: '',
        realprem_y_rate: ''
      },
      pickerOptions0: {
        disabledDate(time) {
          let now = new Date(); //当前日期
          let nowYear = now.getFullYear(); //当前年
          let lastMonthDate = new Date(); //上月日期
          lastMonthDate.setDate(1);
          //alert(lastMonthDate)
          lastMonthDate.setMonth(lastMonthDate.getMonth());
          let lastMonth = lastMonthDate.getMonth();
          if(lastMonth == 0) {
            nowYear = nowYear - 1
            lastMonth = 12
          }
          let lastMonthStartDate = new Date(nowYear, lastMonth, 1);
        //   console.log(lastMonthStartDate)
          return time.getTime() > lastMonthStartDate.getTime();
        }
      },
    }
  },
  watch: {
    '$route': 'initReq',
    month: function (newValue, oldValue) {
      this.initReq()
    }
  },
  methods: {
    chooseType (value) {
      this.req.conRateType = value
      this.initReq()
    },
    arrow (id, cid) {
      let el = document.getElementById(id)
      let content = document.getElementById(cid)
      let classN = el.getAttribute('class')
      if (!classN.includes('arrow-go')) {
        el.classList.remove('arrow-back')
        el.classList.add('arrow-go')
        content.classList.add('open')
      } else {
        el.classList.remove('arrow-go')
        el.classList.add('arrow-back')
        content.classList.remove('open')
      }
    },
    search () {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
        // target: document.querySelector('#getPolicyList')
      })
      let that = this

      api.post(url.getTeamConRate, this.req, function (res) {
        console.log(res.data.data)
        that.result = res.data.data
        loading.close();
      })
    },
    formatter (value) {
      let result = ''
      if (value) {
        let year = value.getFullYear()
        let month = value.getMonth() + 1
        if (month < 10) {
          month = '0' + month
        }
        result = year + '' + month
      }
      // console.log(result)
      return result
    },

    initReq () {
      console.log('router param===========' + this.$route.params)
      var pid = this.$route.params.pid
      var teamCode = this.$route.params.teamCode
      let tname = this.$route.params.name
      this.username = tname.substr(0, tname.length - 1);
      this.req.billcdDate = this.formatter(this.month)

      if (teamCode.substring(0, 1) === 'Q') {
        this.req.teamType = 'AREA'
        this.req.areatlCode = pid
        this.req.grouptlCode = null
        this.req.depttlCode = null
      } else if (teamCode.substring(0, 1) === 'B') {
        this.req.teamType = 'DEPT'
        this.req.depttlCode = pid
        this.req.grouptlCode = null
        this.req.areatlCode = null
      } else {
        this.req.teamType = 'GROUP'
        this.req.grouptlCode = pid
        this.req.depttlCode = null
        this.req.areatlCode = null
      }

      this.search()
    }

  },
  mounted () {
    
  },
  activated() {
    this.month = new Date();
    this.initReq()
  }
}
</script>

<style scoped>
.main-div{
    /* margin: 10px; */
    height: 100%;
    /* min-height: 100%; */
}
.teamConrate{
    width:96%;
    margin: 0 auto;
    margin-top: 20px;
    background:#fff;
    height: calc(100% - 100px);
}
.header, .main{
    width: 94%;
    margin: auto;
    padding: 20px 0 10px 0;
}
.header{
    height: 30px;
}
.header label{
    color: #111111;
    font-size:18px;
    display: block;
    float: left;
}
.right{
    float: right;
    font-size: 10px;
}
.el-input__inner{
    width: 100px;
    height: 20px;
}
.el-date-editor.el-input, .el-date-editor.el-input__inner{
    width: 120px;
    opacity: 1;
    cursor: pointer;
}
.el-input--mini .el-input__inner{
    height: 20px;
}
.el-input--mini .el-input__icon {
    color: #194793;
    line-height: 20px;
}
.el-input__prefix{
    left: 0;
}
.main{
    padding-bottom: 30px;
    height: auto;
}
.content{
    height: auto;
    font-size: 12px;
    color: #111111;
}
.option{
    height: 50px;
}
.option ul{
    list-style: none;
}
.option li{
    /* padding: 0 10px; */
    line-height: 30px;
    display: block;
    float: left;
    width: 33%;
    text-align: center;
    cursor: pointer;
    /* margin: 0 auto 0 15%; */
}
.option li span{padding: 4px 10px;}
.option li:hover span{
    border-bottom: 3px solid #194793;
}
.typeSelected span{
    border-bottom: 3px solid #194793;
}
.moneyTotal{
    min-height: 100px;
}
.moneyTotal{
    margin-top: 30px;
}
.title{
    height: 31px;
    background: #F7F7F7;
    /* box-shadow: 0px 0px 0.5px 0.5px rgba(0,0,0,0.2); */
    border: 1px solid #E5E5E5;
    line-height: 31px;
    font-size: 13px;
    font-weight: 500;
    padding-left: 18px;
}
.arrow{
    width: 8px;
    height: 14px;
    float: right;
    position: relative;
    top:8px;
    right: 15px;
    transform:rotate(90deg);
}
.money-content{
    min-height: 69px;
    display: block;
    transition-duration: 1s;
    /* box-shadow: 0px 1px 0.5px 0.5px rgba(0,0,0,0.2); */
    border: 1px solid #E5E5E5;
    margin-top: -1px;
}
table{
    width: 100%;
    text-align: center;
    border-top: none;
}
table td{
    width: 17%;
    height: 28px;
}
thead{
    color: #C6A970;
}
tbody span:nth-child(1){
    float: left;
}
tbody span:nth-child(2){
    float: right;
}
.look{
    color: #5B9FEC;
    padding: 0 6%;
}
@keyframes arrow{
    0%{
        transform:rotate(0deg)
    }
    25%{
        transform:rotate(18deg)
    }
    50%{
        transform:rotate(36deg)
    }
    75%{
        transform:rotate(54deg)
    }
    100%{
        transform:rotate(90deg)
    }
 }
 @keyframes back{
    0%{
        transform:rotate(90deg)
    }
    25%{
        transform:rotate(54deg)
    }
    50%{
        transform:rotate(36deg)
    }
    75%{
        transform:rotate(18deg)
    }
    100%{
        transform:rotate(0deg)
    }
 }

.arrow-go{
    animation-name:back;
    transform:rotate(0deg);
    transition-timing-function:ease-in-out;
    animation-duration:0.1s;
}
.arrow-back{
    animation-name:arrow;
    transform:rotate(90deg);
    transition-timing-function:ease-in-out;
    animation-duration:0.1s;
}
.open{
  display: none;
}
.content thead th{ padding:8px 0;}
</style>



// WEBPACK FOOTER //
// src/pages/performance/teamConRate.vue